// Email Configuration for Firebase Cloud Function
// Brevo API credentials are stored securely in Firebase Functions (server-side)
// The frontend calls the Cloud Function which handles email sending

import { Credentials } from '../../../../assets/features/Credentials';

// Get Firebase Project ID to construct Cloud Function URL
const firebaseProjectId = Credentials.FIREBASE_PROJECT_ID || import.meta.env.VITE_FIREBASE_PROJECT_ID || '';

// Cloud Function URL for sending emails
const CLOUD_FUNCTION_URL = firebaseProjectId 
    ? `https://europe-west1-${firebaseProjectId}.cloudfunctions.net/sendEmail`
    : '';

export const emailConfig = {
    // Cloud Function URL (replaces direct Brevo API calls)
    CLOUD_FUNCTION_URL,
    
    // Sender information (public, used in email templates)
    BREVO_FROM_EMAIL: import.meta.env.VITE_BREVO_FROM_EMAIL || Credentials.BREVO_FROM_EMAIL || 'orcamento@roadyleiria.com',
    BREVO_FROM_NAME: import.meta.env.VITE_BREVO_FROM_NAME || Credentials.BREVO_FROM_NAME || 'Roady Leiria',
    
    // Form-specific receiver emails (public, used to route emails to correct departments)
    BREVO_TO_EMAIL_BUDGET: import.meta.env.VITE_BREVO_TO_EMAIL_BUDGET || Credentials.BREVO_TO_EMAIL || 'orcamento@roadyleiria.com',
    BREVO_TO_EMAIL_CONTACT: import.meta.env.VITE_BREVO_TO_EMAIL_CONTACT || Credentials.BREVO_TO_EMAIL || 'orcamento@roadyleiria.com',
    BREVO_TO_EMAIL_WECALL: import.meta.env.VITE_BREVO_TO_EMAIL_WECALL || Credentials.BREVO_TO_EMAIL || 'orcamento@roadyleiria.com',
    BREVO_TO_EMAIL_RECRUITMENT: import.meta.env.VITE_BREVO_TO_EMAIL_RECRUITMENT || Credentials.BREVO_TO_EMAIL || 'orcamento@roadyleiria.com',
    
    // Legacy fields (kept for backward compatibility, but no longer used for API calls)
    BREVO_API_KEY: '', // Moved to Cloud Function
    BREVO_API_URL: CLOUD_FUNCTION_URL, // Now points to Cloud Function
};
